import {Route, Routes} from 'react-router-dom';
import ChatPage from '../pages/ChatPage';

export default function UserRoutes() {
    return (
        <Routes>
            <Route path='/' element={<ChatPage />} />
            <Route path='/:id' element={<ChatPage />}/>
        </Routes>
    );
}
